import { auth } from './firebase';

export interface SongAnalysis {
  title: string;
  artist: string;
  summary: string;
  profanityAnalysis: string;
  hasProfanity: boolean;
  profanityLevel: 'none' | 'mild' | 'moderate' | 'heavy';
  analyzedAt: string;
  model: string;
  lyricsSource?: 'ai_knowledge' | 'web_search' | 'manual';
  lyricsConfidence?: 'high' | 'low';
}

// The co-approval DJ's page sends its link instead of a DJ account (ITER-194)
export interface CoApprovalDjCredential {
  eventId: string;
  token: string;
}

function coApprovalDjFields(coApprovalDj: CoApprovalDjCredential | undefined): Record<string, string> {
  return coApprovalDj ? { coApprovalDjEventId: coApprovalDj.eventId, coApprovalDjToken: coApprovalDj.token } : {};
}

export async function analyzeSong(title: string, artist: string, coApprovalDj?: CoApprovalDjCredential): Promise<SongAnalysis> {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Authentication required');
  }
  const idToken = await user.getIdToken();

  const response = await fetch('/api/analyzeSong', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`,
    },
    body: JSON.stringify({ title: title.trim(), artist: artist.trim(), ...coApprovalDjFields(coApprovalDj) }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Analysis failed (${response.status})`);
  }

  return response.json();
}

export async function reanalyzeSongWithLyrics(
  title: string,
  artist: string,
  lyrics: string,
  coApprovalDj?: CoApprovalDjCredential
): Promise<SongAnalysis> {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Authentication required');
  }
  const idToken = await user.getIdToken();

  const response = await fetch('/api/analyzeSong', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`,
    },
    body: JSON.stringify({ title: title.trim(), artist: artist.trim(), lyrics, ...coApprovalDjFields(coApprovalDj) }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Re-analysis failed (${response.status})`);
  }

  return response.json();
}
